export const UPDATE_TABLE = 'UPDATE_TABLE';
export const ACCESS_LOCK = 'ACCESS_LOCK';
export const RESET_TABLE = 'RESET_TABLE';
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION';
export const SET_DEFAULT_RECORDS_PER_PAGE = 'SET_DEFAULT_RECORDS_PER_PAGE';